import React from 'react';
import styles from './card.module.scss';

interface CardProps {
    children: React.ReactNode ;
    className: string;
}

const Card: React.FC<CardProps> = ({ children, className }: CardProps) => {
  return (
    <div className={styles.card}>
      {children}
    </div>
  );
};

export default Card;